import { createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleGeneratedCertificate } from '../../Redux/slices/certificateWebsocket';
import { handleNotificationAlert, handleNotificationCount } from '../../Redux/slices/notification';
import {
  establishCertificateWebSocketConnection,
  establishWebSocketConnection
} from './websocketConnection';

const WebSocketContext = createContext(null);
export { WebSocketContext };

const CertificateWebSocketContext = createContext(null);
export { CertificateWebSocketContext };

const WebSocketProvider = ({ children }) => {
  let ws;
  let certificateWs = null;

  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (!ws && isLoggedIn && user) {
      ws = establishWebSocketConnection(user.id);
      if (ws) {
        ws.onmessage = function (event) {
          const eventData = JSON.parse(event.data);
          try {
            dispatch(handleNotificationCount(eventData));
            dispatch(handleNotificationAlert(eventData));
          } catch (err) {
            console.log(err);
          }
        };
        ws.onclose = (e) => {
          console.log(
            `Socket is closed. Reconnect will be attempted in ${Math.min(10000 / 1000)} second.`,
            e.reason
          );
          // connectInterval = setTimeout(this.check, Math.min(10000, that.timeout)); //call check function after timeout
        };
        // websocket onerror event listener
        ws.onerror = (err) => {
          console.error('Socket encountered error: ', err.message, 'Closing socket');
          ws.close();
        };
      }
    }
    if (!certificateWs && isLoggedIn && user) {
      try {
        if (!certificateWs) {
          let user = JSON.parse(localStorage.getItem('cdmin_user'));

          let certificateWs = establishCertificateWebSocketConnection(user.token);
          if (certificateWs) {
            certificateWs.onmessage = function (certificate) {
              const certificateData = JSON.parse(certificate.data);
              dispatch(handleGeneratedCertificate(certificateData));
            };
            certificateWs.onclose = (e) => {
              console.log(
                `Socket is closed. Reconnect will be attempted in ${Math.min(
                  10000 / 1000
                )} second.`,
                e.reason
              );
              // connectInterval = setTimeout(this.check, Math.min(10000, that.timeout)); //call check function after timeout
            };
            // websocket onerror event listener
            certificateWs.onerror = (err) => {
              console.error('Socket encountered error: ', err.message, 'Closing socket');
              certificateWs.close();
            };
          }
        }
      } catch (error) {
        // dispatch(getUsersFailure());
      }
    }
  }, [isLoggedIn, user]);

  return (
    <CertificateWebSocketContext.Provider value={certificateWs}>
      <WebSocketContext.Provider value={ws}>{children}</WebSocketContext.Provider>;
    </CertificateWebSocketContext.Provider>
  );
};

export default WebSocketProvider;
